import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ServiceCatalogFacade } from '../../../store/self-diagnostic/service-catalog/facade';
import { ServiceCategoryModel, ServiceMasterCategoryModel, ServiceModel } from '../../../store/self-diagnostic/service-catalog/model';
import { List } from '../../../core/infrastructure/linq';
import { SelfDiagnosisModel } from '../../../store/self-diagnostic/self-diagnosis/model';
import { Router } from '@angular/router';
import { SelfDiagnosisFacade } from '../../../store/self-diagnostic/self-diagnosis/facade';
import { UserFacade } from '../../../store/user/facade';
import { AppConstants } from '../../../core/constants/app-constants';

@Component({
  selector: 'shared-search-service-full',
  templateUrl: './search-service-full.component.html',
  styleUrls: ['./search-service-full.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class SearchServiceFullComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  translate = inject(TranslateService);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private selfDiagnosisFacade = inject(SelfDiagnosisFacade);
  sanitizer = inject(DomSanitizer);
  private titleService = inject(Title);
  private userFacade = inject(UserFacade);

  //public entity: TopServiceModel = new TopServiceModel();
  //@Output("onSave") public onSave$ = new EventEmitter<TopServiceModel>();

  //private services: List<ServiceModel> = new List<ServiceModel>();
  //private serviceCatalogFacadeSubsription: Subscription;

  //public searchDataSource: DataSource;
  //public selectedMenuItem: ServiceModel;

  public isUkLanguage: boolean;

  public masterCategories: ServiceMasterCategoryModel[] = [];
  public searchText: string;

  private services: List<ServiceModel> = new List<ServiceModel>();
  public searchDataSource: DataSource;
  private knowledgeLibraryMessage: string;

  public selectedSearchResult: any;

  private selfDiagnosis: List<SelfDiagnosisModel> = new List<SelfDiagnosisModel>();

  private userFacadeSub: Subscription;
  private serviceCatalogFacadeSub: Subscription;
  private selfDiagnosisFacadeSub: Subscription;

  public ngOnDestroy() {
    this.userFacadeSub?.unsubscribe();
    this.serviceCatalogFacadeSub?.unsubscribe();
    this.selfDiagnosisFacadeSub?.unsubscribe();
  }

  public async ngOnInit() {
    this.userFacadeSub = this.userFacade.selected().subscribe(user => {
      if (user) {
        this.isUkLanguage = !user.language || user.language == AppConstants.LANGUAGE_UK;
      }
    });

    // Page title
    this.translate.get('TITLE_SERVICES_PAGE').subscribe(page => {
      this.translate.get('TITLE_MAIN').subscribe(main => {
        this.titleService.setTitle(page + ' ' + main);
      });
    });

    this.serviceCatalogFacadeSub = this.serviceCatalogFacade.filtered$.subscribe(s$ => {
      if (s$) {
        this.services = new List<ServiceModel>(s$);

        let categories = this.services
          .Select(s => s.category)
          .DistinctBy(c => c.code)
          .OrderBy(c => c.nameUa)
          .Select(
            c =>
              <ServiceCategoryModel>{
                id: c.id,
                nameUa: c.nameUa,
                nameRu: c.nameRu,
                descriptionUa: c.descriptionUa,
                descriptionRu: c.descriptionRu,
                code: c.code,
                masterCategoryId: c.masterCategoryId,
                services: this.services
                  .Where(s => s.categoryId == c.id)
                  .OrderBy(s => s.nameUa)
                  .ToArray(),
                iconBody: c.iconBody,
                iconType: c.iconType,
              }
          );

        this.masterCategories = this.services
          .Select(s => s.category)
          .Where(c => c.masterCategory != null)
          .Select(c => c.masterCategory)
          .DistinctBy(mc => mc.code)
          .OrderByDescending(mc => mc.priority)
          .ThenBy(mc => mc.nameUa)
          .Select(
            mc =>
              <ServiceMasterCategoryModel>{
                id: mc.id,
                nameUa: mc.nameUa,
                nameRu: mc.nameRu,
                code: mc.code,
                categories: categories
                  .Where(c => c.masterCategoryId == mc.id)
                  .OrderBy(c => c.nameUa)
                  .ToArray(),
                iconType: mc.iconType,
                iconBody: mc.iconBody,
              }
          )
          .ToArray();
      }
    });

    this.selfDiagnosisFacadeSub = this.selfDiagnosisFacade.entities$.subscribe(sd$ => {
      this.selfDiagnosis = new List(sd$);
    });

    this.translate.get('KNOWLEDGE_LIBRARY').subscribe(value => {
      this.knowledgeLibraryMessage = value + ' (new)';
    });

    this.searchDataSource = new DataSource({
      key: 'ID',
      paginate: false,
      load: loadOptions => {
        let result = new List<any>();

        if (loadOptions.searchValue) {
          let searchString = loadOptions.searchValue.toLowerCase();

          result.AddRange(
            this.selfDiagnosis
              .Where(sd => sd.keyWords != null)
              .Where(s =>
                new List(
                  s.keyWords
                    .split(',')
                    .map(key => key.trim().toLowerCase())
                    .filter(key => key.includes(searchString))
                ).Any()
              )
              .Select(sd => {
                let service = this.services.Single(s => s.id == sd.serviceId);

                return {
                  id: sd.id,
                  nameUa: sd.nameUa,
                  nameRu: sd.nameRu,
                  service: service,
                  priority: sd.priority,
                  type: 'self-diagnosis',
                  description: this.knowledgeLibraryMessage,
                  iconType: sd.iconType,
                  iconBody: sd.iconBody,
                };
              })
              .ToArray()
          );

          result.AddRange(
            this.selfDiagnosis
              .Where(sd => sd.nameUa.toLowerCase().includes(searchString) || sd.nameRu.toLowerCase().includes(searchString))
              .Select(sd => {
                let service = this.services.Single(s => s.id == sd.serviceId);

                return {
                  id: sd.id,
                  nameUa: sd.nameUa,
                  nameRu: sd.nameRu,
                  service: service,
                  priority: sd.priority,
                  type: 'self-diagnosis',
                  description: this.knowledgeLibraryMessage,
                  iconType: sd.iconType,
                  iconBody: sd.iconBody,
                };
              })
              .ToArray()
          );

          result.AddRange(
            this.services
              .Where(s => s.nameUa.toLowerCase().includes(searchString) || s.nameRu.toLowerCase().includes(searchString))
              .Select(s => {
                return {
                  id: s.id,
                  code: s.code,
                  nameUa: s.nameUa,
                  nameRu: s.nameRu,
                  category: s.category,
                  priority: s.priority,
                  type: 'service',
                };
              })
              .ToArray()
          );

          result.AddRange(
            this.services
              .Where(s => s.keyWords != null)
              .Where(s =>
                new List(
                  s.keyWords
                    .split(',')
                    .map(key => key.trim().toLowerCase())
                    .filter(key => key.includes(searchString))
                ).Any()
              )
              .Select(s => {
                return {
                  id: s.id,
                  code: s.code,
                  nameUa: s.nameUa,
                  nameRu: s.nameRu,
                  category: s.category,
                  priority: s.priority,
                  type: 'service',
                };
              })
              .ToArray()
          );

          result = result
            .DistinctBy(e => e.id)
            .OrderByDescending(e => e.priority)
            .ThenBy(e => e.nameUa);
        }

        return result.ToArray();
      },
    });
  }

  public async createOrder(serviceId: number) {
    let service = this.services.First(s => s.id == serviceId);

    this.router.navigate(['/orders/order'], {
      queryParams: {
        categoryId: service.category.code,
        categoryName: this.isUkLanguage ? service.category.nameUa : service.category.nameRu,
        serviceId: service.code,
        serviceName: this.isUkLanguage ? service.nameUa : service.nameRu,
        serviceTypeId: null,
      },
    });
  }

  public async onFocusIn() {
    //set overlay for body
    document.body.classList.add('overlay-on');
    //get position search input
    var searchServicePosition = document.getElementById('search-service').getBoundingClientRect();
    //calculate exclude toolbar height (minus for transform top) + shadow
    var positionMInusToolbar = -searchServicePosition.top + document.getElementById('appToolbar').offsetHeight + 10;
    //set position
    document
      .getElementById('search-service')
      .setAttribute(
        'style',
        '-webkit-transform:translateY(' +
          positionMInusToolbar +
          'px); -ms-transform:translateY(' +
          positionMInusToolbar +
          'px); transform:translateY(' +
          positionMInusToolbar +
          'px); '
      );
    document.getElementsByTagName('shared-search-service-full')[0]?.setAttribute('style', 'z-index: 6;');
  }

  public async onFocusOut($event) {
    //show initial view of the catalog
    document.body.classList.remove('overlay-on', 'overlay-input');
    document
      .getElementById('search-service')
      .setAttribute('style', '-webkit-transform:translateY(0); -ms-transform:translateY(0); transform:translateY(0);');
    document.getElementsByTagName('shared-search-service-full')[0]?.setAttribute('style', '');
  }

  public async onInput() {
    //show white overlay
    document.body.classList.add('overlay-input');
  }

  public async selectService($event) {
    let entity = $event.itemData;

    if (entity.type == 'self-diagnosis') {
      this.router.navigate(['/self-diagnostic/self-diagnostic-step', entity.id]);
    } else if (entity.type == 'service') {
      let serviceId = entity.id;

      let selfDiagnosis = this.selfDiagnosis.Where(sd => sd.serviceId == serviceId).ToList();
      //only 1
      if (selfDiagnosis.Count() == 1) {
        this.router.navigate(['/self-diagnostic/self-diagnostic-step', selfDiagnosis.First().id]);
      } else {
        this.createOrder(serviceId);
      }
    }
  }
}
